import { AvatarV2 } from '@cimplico/components';
import { ReactNode } from 'react';
import { UserOverview } from '../../types/user';

type UserAvatarProps = {
    size?: 'mini' | 'xs' | 'sm' | 'base' | 'lg' | 'xl' | 'jumbo';
    tooltip?: string;
    tooltipDirection?: 'top' | 'right' | 'bottom' | 'left';
    badge?: ReactNode;
    ring?: boolean;
    user: Partial<UserOverview>;
    colour?: string;
    onRemove?: () => void;
};

function UserAvatar({ size = 'sm', tooltip, tooltipDirection, badge, ring, user, colour, onRemove }: UserAvatarProps): JSX.Element {
    let avatarLabel: string | undefined;

    if (user.firstName && user.lastName) {
        avatarLabel = user.firstName[0] + user.lastName[0];
    }

    return (
        <div className="shrink-0">
            <AvatarV2
                ring={ring}
                size={size}
                alt={avatarLabel}
                src={user.avatarUrl || undefined}
                color={colour || user.profileHexColour}
                tooltip={tooltip}
                tooltipDirection={tooltipDirection}
                badge={badge}
                onRemove={onRemove}
            />
        </div>
    );
}

export default UserAvatar;
